import { render } from "./CargoPublico.vue?vue&type=template&id=cc65dfb8"
import script from "./CargoPublico.vue?vue&type=script&lang=js"
export * from "./CargoPublico.vue?vue&type=script&lang=js"

import "./CargoPublico.vue?vue&type=style&index=0&id=cc65dfb8&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__